<template>
  <div class="room-type-wrapper">
    <span class="type-item " v-for="(item,index) in option" :class="{active:index==activeIndex}" :key="item+index" @click="changeActive(index)">{{item}}</span>


  </div>
</template>

<script>
export default {
    props:{
        value:{
            type:Number||String,
            required:false,
            default:0
        },
        option:{
            type:Array,
            required:true
        }
    },
    data(){
        return {
            activeIndex:this.value
        }
    },
    created(){
        
    },
    methods:{
        changeActive(index){
            this.activeIndex = index
            this.$emit('input', index)
        }
    }
    
};
</script>

<style lang="scss" scoped>
.room-type-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .type-item {
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 10px;
    margin: 20px 0;
    font-size: 12px;
    cursor: pointer;
  }
  & .active {
    background: #21c09e;
    color: #fff;
    &::after {
      content: "";
      display: block;
      width: 0;
      margin: 0 auto;
      border-top: 5px solid #21c09e;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
    }
  }
}
</style>

